/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const CLOSE_CIRCLE_VIEWBOX = 32;

const CLOSE_CIRCLE_RING_PATH =
  'M2.6665 15.9998C2.6665 23.3587 8.64097 29.3332 15.9998 29.3332C23.3587 29.3332 29.3332 23.3587 29.3332 15.9998C29.3332 8.64097 23.3587 2.6665 15.9998 2.6665C8.64097 2.6665 2.6665 8.64097 2.6665 15.9998V15.9998';

const CLOSE_CIRCLE_X_PATH = 'M20 12L12 20M12 12L20 20';

const iconPropTypes = {
  size: PropTypes.number,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Close in circle (32×32). Color via `stroke` / `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const CloseCircleIcon = ({
  size = 32,
  stroke = 'currentColor',
  strokeWidth = 2.66667,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${CLOSE_CIRCLE_VIEWBOX} ${CLOSE_CIRCLE_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d={CLOSE_CIRCLE_RING_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d={CLOSE_CIRCLE_X_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CloseCircleIcon.propTypes = iconPropTypes;

export { CloseCircleIcon };
export default CloseCircleIcon;
